import React from 'react';
import { Button } from 'antd';
import { PageConstant } from '../../../constants';
import Info from '../../../assets/img/info.svg';

const defaultTitle = <> <img src={Info} /> Your next steps...</>;
const DefaultDescription = ({ name }) => <span>
    Unfortunately, you do not meet the requirements to proceed with the fast-track application process for {name}. Please, go to the Talent Portal where you can explore other jobs and discover your next steps.
</span>

const FastrackFailedCard = ({ name, title, description, service }) => {
    const failed_title = title || defaultTitle;
    const failed_description = description || <DefaultDescription name={name} />
    const redirectLink = PageConstant.DASHBOARD_DEV;

    return (
        <div className='Vetsmith-item failed-section'>
            <div className='failed-section-content'>
                <div className='failed-title'>{failed_title}</div>
                <div className='failed-description'>{failed_description}</div>
            </div>
            <Button type="primary" onClick={() => {
                localStorage.removeItem('redirect_url');
                service.createPassword(redirectLink)
            }}>Go back to Talent Portal</Button>
        </div>
    );
}

export default React.memo(FastrackFailedCard);